import { Link } from 'gatsby';

import { usePageContext } from '~components/PageDataProvider/PageDataProvider';
import { useAppSelector } from '~hooks/useRedux';

type Props = {
    url?: string;
    to?: string;
    href?: string;
    className?: string;
    id?: string;
    label?: string;
    styleType?: string;
    databaseId?: string;
    linkRelationship?: string;
    cssClasses?: string;
    maskType?: string;
    target?: string;
    rel?: string;
    childItems?: any;
};

const allidURL = (link: string, allid: string): string => {
    try {
        if (!allid) {
            throw new Error('Missing Alliance ID');
        }

        const newUrl = new URL(link);
        newUrl.searchParams.append('allid', allid);

        return newUrl;
    } catch (error) {
        console.error('[allidURL]', `link: (${link})`, error);

        return link;
    }
};

const Anchor = ({ children, url, to, href, ...attributes }: React.PropsWithChildren<Props>) => {
    const { location } = usePageContext();
    const allid = useAppSelector((state) => state.global.allianceId);
    const isSMB = ['/enroll/'].some((path) => location.pathname.includes(path));

    let link = url || to || href;

    if (!link) {
        return <></>;
    }

    const allidLink = isSMB ? link : allidURL(link, allid);
    const {
        id,
        label,
        styleType,
        databaseId,
        linkRelationship,
        cssClasses,
        className,
        maskType,
        childItems,
        ...other
    } = attributes;
    delete other.class;

    let internal = /^\/(?!\/)/.test(link);
    const file = /\.[0-9a-z]+$/i.test(link) || link.includes('/static');

    if (
        link.includes('mu-admin') ||
        link.includes(process.env.GATSBY_SITE_URL + '/medicare') ||
        link.includes('ehealthinsurance.com/medicare')
    ) {
        internal = true;
        let pathname = new URL(link).pathname;
        if (pathname.includes('/medicare/')) {
            pathname = pathname.replace('/medicare/', '/');
        }
        const hash = new URL(link).hash;
        link = `${pathname}${hash ? hash : ''}`;
    }

    if (internal) {
        if (file) {
            return (
                <a href={link} {...other}>
                    {children}
                </a>
            );
        }

        return (
            <Link to={allidLink} className={className} {...other}>
                {children}
            </Link>
        );
    }
    return (
        <a href={link} className={className} {...other}>
            {children}
        </a>
    );
};

export default Anchor;
